/* eslint-disable no-unused-vars */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles
} from '@material-ui/core';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import MoneyIcon from '@material-ui/icons/Money';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56
  },
  differenceIcon: {
    color: colors.red[900]
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1)
  }
}));

const PendingClients = ({ className, PendingArray, PendingArrayPercentage, totalArray, ...rest }) => {
  const classes = useStyles();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              PENDING CLIENTS
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {totalArray === 0 ? '......' : PendingArray}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <PeopleOutlineIcon />
            </Avatar>
          </Grid>
        </Grid>
        <Box
          mt={2}
          display="flex"
          alignItems="center"
        >
          <ArrowUpwardIcon className={classes.differenceIcon} />
          <Typography
            className={classes.differenceValue}
            variant="body2"
          >
            {totalArray === 0 ? '......' : PendingArrayPercentage.toFixed(2)}% &nbsp;
          </Typography>
          <Typography
            color="textSecondary"
            variant="caption"
          >
            Of total submitted forms
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

PendingClients.propTypes = {
  className: PropTypes.string
};

export default PendingClients;
